import { makeEntityOptionsService } from '../../../services/common/entity-options/entity-options-service-factory';
import { IEntityOptionsRepository } from './entity-options-repository';
import { EntityOptionsRepositoryImpl } from './entity-options-repository-impl';

let entityOptionsRepository: IEntityOptionsRepository;

export function makeEntityOptionsRepository(): IEntityOptionsRepository {
  if (!entityOptionsRepository) {
    entityOptionsRepository = new EntityOptionsRepositoryImpl(
      makeEntityOptionsService(),
    );
  }

  return entityOptionsRepository;
}
